<template>
  <router-view />
</template>

<style>
@import "./assets/common/css/bootstrap.min.css";
@import "./assets/common/css/style.css";
</style>
